import React from 'react';
import {Route, Switch} from 'react-router-dom';
import './styles/App.scss';
import './i18n';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import {AgrofyTheme, Theme} from 'agrofy-ui-components';

const App = props => {
  const routes = props && props.routes;
  const initialData = props && props.initialData;
  const { t } = useTranslation();
  const baseUrl = process.env.RAZZLE_BASE_URL || window.env.RAZZLE_BASE_URL;
  const sparePartsUrl = process.env.RAZZLE_SPARE_PARTS_URL || window.env.RAZZLE_SPARE_PARTS_URL;

  return routes && 
  <Theme theme={AgrofyTheme}>
    <div className="agrofy">
      <div>
        <Helmet>
          <title>{t('head_title')}</title>
          <meta name="description" content={t('head_description')} />
          <link rel="canonical" href={`${baseUrl}${sparePartsUrl}`}/>
        </Helmet>
      </div>
      <div className="agrofy__container ">
        <Switch>
          {routes.map((route, index) =>
            (
              <Route
                key={index}
                path={route.path}
                exact
                render={props =>
                  React.createElement(route.component, {
                    ...props,
                    initialData: initialData[index] || null
                  })}
              />
            )
          )}
        </Switch>
      </div>
    </div>
  </Theme>
}

export default App;
